// Phone number utility functions

// Validate phone number (10 digits without country code)
export const validatePhoneNumber = (phone) => {
  if (!phone) return false;
  
  // Remove spaces, dashes, dots for validation
  const cleanPhone = phone.replace(/[-.\s]/g, '');
  
  // Should be exactly 10 digits
  return /^\d{10}$/.test(cleanPhone);
};

// Validate country code format
export const validateCountryCode = (countryCode) => {
  if (!countryCode) return false;
  
  // Should start with + followed by 1-3 digits
  return /^\+\d{1,3}$/.test(countryCode);
};

// Extract country code from full phone number
export const extractCountryCode = (fullPhone) => {
  if (!fullPhone) return '+91'; // Default to India
  
  const cleanPhone = fullPhone.replace(/[^\d+]/g, '');
  
  // Try to match common country codes
  const countryCodes = ['+1', '+44', '+91', '+61', '+971', '+966', '+65', '+60', '+81', '+86'];
  
  for (const code of countryCodes) {
    if (cleanPhone.startsWith(code)) {
      return code;
    }
  }
  
  return '+91'; // Default to India
};

// Extract phone number without country code
export const extractPhoneNumber = (fullPhone) => {
  if (!fullPhone) return '';
  
  const cleanPhone = fullPhone.replace(/[^\d+]/g, '');
  const countryCode = extractCountryCode(fullPhone);
  
  return cleanPhone.replace(countryCode, '');
};

// Combine country code and phone number
export const combinePhoneParts = (countryCode, phone) => {
  if (!countryCode || !phone) return '';
  
  const cleanCountryCode = countryCode.trim();
  const cleanPhone = phone.replace(/[-.\s]/g, '');
  
  return `${cleanCountryCode}${cleanPhone}`;
};

// Format phone number for display (with country code)
export const formatPhoneNumber = (countryCode, phone) => {
  if (!countryCode || !phone) return '';
  
  const cleanPhone = phone.replace(/[-.\s]/g, '');
  
  return `${countryCode} ${cleanPhone}`;
};

// Get placeholder text based on country
export const getPhonePlaceholder = () => {
  return '98765 43210';
};

// Common country codes for reference
export const countryCodes = [
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+1', name: 'USA/Canada', flag: '🇺🇸' },
  { code: '+44', name: 'UK', flag: '🇬🇧' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+971', name: 'UAE', flag: '🇦🇪' },
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬' },
  { code: '+60', name: 'Malaysia', flag: '🇲🇾' },
  { code: '+81', name: 'Japan', flag: '🇯🇵' },
  { code: '+86', name: 'China', flag: '🇨🇳' },
  { code: '+49', name: 'Germany', flag: '🇩🇪' },
  { code: '+33', name: 'France', flag: '🇫🇷' },
  { code: '+39', name: 'Italy', flag: '🇮🇹' },
  { code: '+34', name: 'Spain', flag: '🇪🇸' },
  { code: '+7', name: 'Russia', flag: '🇷🇺' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪' },
  { code: '+47', name: 'Norway', flag: '🇳🇴' },
  { code: '+358', name: 'Finland', flag: '🇫🇮' },
];
